<div class="d-flex flex-column" style="max-height: 100%;">
    <div class="pb-2 d-flex flex-md-row flex-column">
        <div>
            <app-assignments-filter-display [filterModelSubject]="assignmentsStateService.upcomingAssignmentsFilterSubject">
            </app-assignments-filter-display>
        </div>
        <div class="flex-grow-1"></div>
    </div>
    <div class="flex-grow-1 overflow-y-auto">
        <app-assignments-list [assignmentSubject]="assignmentsStateService.upcomingAssignmentsSubject"
            [eventType]="assignmentEventTypes.RouteToDetails" [displayFinanceInformation]="true">
        </app-assignments-list>
    </div>
</div>